import React, { useState, useRef, useEffect, useMemo } from 'react';
import { Box, CssBaseline, Toolbar, Fab, Grid, Button,InputLabel, Select,FormControl, Dialog, DialogTitle, DialogContent, DialogActions, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import Navbar from '../Components/LandingComponent/Navbar';
import SideDrawer from '../Components/newcomponents/SideDrawer';
import Column from '../Components/Column';
import AddCardDialog from '../Components/AddCardDialog';
import AddRiskCardDialog from '../Components/AddRiskCardDialog';
import AddIssueCardDialog from '../Components/AddIssueCardDialog';
import AddCRMCardDialog from '../Components/AddCRMCardDialog';
// import RiskCardDetailsDialog from '../Components/RiskCardDetailsDialog';
import Footer from '../Components/LandingComponent/Footer';
import { Add as AddIcon, Settings as SettingsIcon, CloudUpload as CloudUploadIcon, FileDownload as FileDownloadIcon, ChevronLeft as ChevronLeftIcon, ChevronRight as ChevronRightIcon, ViewList as ViewListIcon, ViewModule as ViewModuleIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { db } from '../Components/auth/firebaseConfig'; // Adjust the path if necessary
import { collection, getDoc, where, query, getDocs, orderBy, addDoc, updateDoc, doc, deleteDoc, onSnapshot, writeBatch } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom'; // To access the URL params and navigate
import { fetchBoardColumns, fetchUserDetails, fetchBoardDetails, fetchCardsForBoard, fetchProjectDetails, saveCard, deleteTask, fetchBoards, fetchAssignedGroupsByEmail } from "../DatabaseApis/DBQuery";
import { fetchUsersAndTenants, fetchUserNameById, fetchUserEmailById, fetchUserIdByEmail } from '../DatabaseApis/DBQuery';
import sendEmail from '../utils/SendEmail';
import { useTransitionMatrix } from '../Components/hooks/useTransitionMatrix';
import TransitionMatrixSettings from '../Components/newcomponents/TransitionMatrixSettings';
import { cardMatchesRule } from '../Components/Card'; // Import the utility function
import ImportCardsDialog from '../Components/ImportCardsDialog'; // Import the ImportCardsDialog
import ExportCardsDialog from '../Components/ExportCardsDialog';
import { getCookie } from '../utils/cookieUtils';

const priorities = ['Low', 'Medium', 'High', 'Urgent'];

const CardPage = () => {

  const [isDrawerOpen, setIsDrawerOpen] = useState(false); //Controls the state of the side drawer (open/closed).
  const [dialogOpen, setDialogOpen] = useState(false);//Controls whether the card dialog is open for adding/editing a card.
  const [riskDialogOpen, setRiskDialogOpen] = useState(false); // Controls risk card dialog
  const [issueDialogOpen, setIssueDialogOpen] = useState(false); // Controls issue card dialog
  const [crmDialogOpen, setCrmDialogOpen] = useState(false); // Controls CRM card dialog
  const [cards, setCards] = useState([]);//tores all the cards (tasks) associated with the current board.
  const [selectedCard, setSelectedCard] = useState(null);//Stores the card selected for editing.
  const [boardTemplateType, setBoardTemplateType] = useState(''); // Track board template type
  const [draggingCard, setDraggingCard] = useState(null);//Tracks the card being dragged in the drag-and-drop interaction.
  const [dragOverCard, setDragOverCard] = useState(null); // Track which card is being dragged over
  const [horizontalView, setHorizontalView] = useState(false); //Controls the column layout (horizontal or vertical).
  const [viewMode, setViewMode] = useState('kanban'); // Controls view mode: 'kanban' or 'list'
  const { boardId } = useParams();//Extracted from URL parameters to fetch data specific to the board.
  const navigate = useNavigate(); // For navigation between boards
  const drawerRef = useRef(null);//A reference for the drawer element.
  const [boardName, setBoardName] = useState(''); //Stores the board and project names.
  const [prjName, setPrjName] = useState('');
  // const { projectId } = useParams();
  const [projectId, setProjectId] = useState(''); // State to store the projectId
  const [boardType, setBoardType] = useState('General');
  // Add state to track scroll interval
  const [scrollDirection, setScrollDirection] = useState(null);
  const scrollSpeed = 10; // Adjust scroll speed

  const [columns, setColumns] = useState([]);

  const [totalCards, setTotalCards] = useState(0); // Holds the total number of cards
  const [cardsPerColumn, setCardsPerColumn] = useState({}); // Holds card counts for each column
  const [userId, setUserId] = useState(''); // State to store the current user's ID
  // New states for user details
  const [email, setEmail] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [role, setRole] = useState('');
  const [uploadedFileURL, setUploadedFileURL] = useState(null);
  const [uploadedFileType, setUploadedFileType] = useState(null);
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  // Board navigation states
  const [availableBoards, setAvailableBoards] = useState([]);
  const [assignedGroups, setAssignedGroups] = useState([]);
  // Initialize the transition matrix hook with the current project ID
  // This will handle loading the matrix from Firestore and managing its state
  const { isTransitionAllowed, transitionMatrix, setTransitionMatrix, resetTransitionMatrix } = useTransitionMatrix(projectId);

  // State to control the visibility of the transition settings dialog
  const [openTransitionSettings, setOpenTransitionSettings] = useState(false);

  // State for user role
  const [userRole, setUserRole] = useState('');

  // State to store fetched rules
  const [rules, setRules] = useState([]);

  // New state for import dialog
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);

  // State for horizontal scroll indicators
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const scrollContainerRef = useRef(null);

// State for risk management dialog
// const [openRiskDialog, setOpenRiskDialog] = useState(false);
// const [editingRiskCard, setEditingRiskCard] = useState(null);


  const userData = getCookie('userData');

  useEffect(() => {
    const loadColumns = async () => {
      try {
        const transformedColumns = await fetchBoardColumns(boardId);
        setColumns(transformedColumns);
      } catch (error) {
        console.error("Error loading columns:", error);
      }
    };

    loadColumns();
  }, [boardId]);

  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const token = userData.token;
        if (!token) {
          console.error('Token not found in cookie');
          return;
        }

        // Get user details from API
        const data = await fetchUserDetails(token);
        setEmail(data.email);
        setTenantId(data.tenantId);
        // Use API role if available, fallback to cookie role
        const effectiveRole = data.role || userData.role || '';
        const normalizedRole = effectiveRole.toLowerCase();
        setRole(normalizedRole);
        setUserRole(normalizedRole);
        // console.log('Current user role:', normalizedRole); // Commented out to avoid revealing user data
        
        // Fetch userId and assigned groups using email
        try {
          const userIdResult = await fetchUserIdByEmail(data.email);
          setUserId(userIdResult.userId);
          // console.log('Current user ID:', userIdResult.userId); // Commented out to avoid revealing user data
          
          // Also fetch assigned groups for board filter
          const { assignedGroups } = await fetchAssignedGroupsByEmail(data.email);
          setAssignedGroups(assignedGroups);
        } catch (error) {
          console.error('Error fetching user ID or assigned groups:', error);
        }
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };
    getUserDetails();
  }, []);

  // Fetch available boards for board navigation
  useEffect(() => {
    const fetchAvailableBoards = async () => {
      // Wait for assignedGroups to be properly loaded (not just initialized as empty array)
      if (!projectId || !assignedGroups || assignedGroups.length === 0 || !tenantId) return;

      try {
        // Fetch boards using the same logic as List view
        const fetchedBoards = await fetchBoards(projectId, assignedGroups, tenantId);
        
       // Include all boards (including Sprint boards) since we're navigating to different pages
        setAvailableBoards(fetchedBoards);
      } catch (error) {
        console.error('Error fetching available boards:', error);
      }
    };

    fetchAvailableBoards();
  }, [projectId, assignedGroups, tenantId]);

  useEffect(() => {
    const loadBoardDetails = async () => {
      try {
        const boardData = await fetchBoardDetails(boardId);
        if (boardData) {
          setProjectId(boardData.projectId); // Set projectId from fetched data
          // Robustly check for template type
          let templateType = boardData.templateType || boardData.template || '';
          // Fallback: if columns match riskColumns, treat as Risk Management
          const riskColumns = [
            'Risk Identification',
            'Analysis',
            'Mitigation Planning',
            'In Progress',
            'Monitoring',
            'Done',
            'Blocked',
            'Withdrawn'
          ];
          
          // Fallback: if columns match issueColumns, treat as Issue Management
          const issueColumns = [
            'New',
            'Triage',
            'Open',
            'Resolved',
            'Reopen',
            'Rejected',
            'Verification',
            'Closed',
            'Blocked',
            'Withdrawn'
          ];
          
          // Fallback: if columns match crmColumns, treat as CRM
          const crmColumns = [
            'Prospecting',
            'Qualified',
            'Proposal Sent',
            'Negotiation',
            'Won',
            'Lost',
            'Withdrawn'
          ];
          
          // Trim columns for robust matching
          const boardCols = Array.isArray(boardData.columns) ? boardData.columns.map(col => col.trim()) : [];
          if (!templateType && boardCols.length === riskColumns.length && boardCols.every((col, idx) => col === riskColumns[idx])) {
            templateType = 'Risk Management';
          } 
          // Check for Issue Management - exact match with new columns
          else if (!templateType && boardCols.length === issueColumns.length && boardCols.every((col, idx) => col === issueColumns[idx])) {
            templateType = 'Issue Management';
          }
          // Check for CRM - exact match with CRM columns
          else if (!templateType && boardCols.length === crmColumns.length && boardCols.every((col, idx) => col === crmColumns[idx])) {
            templateType = 'CRM';
          }
          // Check for Issue Management by characteristic columns (backwards compatibility)
          else if (!templateType) {
            const characteristicIssueColumns = ['New Issue', 'Issue Identification', 'Analysis', 'Review', 'In Progress', 'Resolved', 'Withdrawn'];
            const hasIssueCharacteristics = characteristicIssueColumns.some(col => boardCols.includes(col));
            
            // Also check if board has a significant number of issue-specific columns
            const issueSpecificTerms = boardCols.filter(col => 
              col.toLowerCase().includes('issue') || 
              col.toLowerCase().includes('withdrawn') ||
              col.toLowerCase().includes('closure') ||
              col.toLowerCase().includes('resolved') ||
              col.toLowerCase().includes('verification')
            );
            
            if (hasIssueCharacteristics && issueSpecificTerms.length >= 2) {
              templateType = 'Issue Management';
            }
          }
          
          console.log('Board Detection:', { templateType, boardCols, boardData: boardData.templateType || boardData.template });
          setBoardTemplateType(templateType);
          setBoardType(boardData.boardType || 'General');
          setBoardName(boardData.boardName);
          const projectData = await fetchProjectDetails(boardData.projectId);
          if (projectData) {
            setPrjName(projectData.prjName);
          }
        } else {
          console.error("Board not found");
        }
      } catch (error) {
        console.error("Error loading board details:", error);
      }
    };
    loadBoardDetails();
  }, [boardId]);

  // Only run this logic for sprint boards that are not already completed.
  useEffect(() => {
    if (boardType === 'Sprint' && cards.length > 0) {
      // Check if every card in the current view has the status 'Done'.
      console.log("Total cards in board at present" + cards.length);
      const allCardsAreDone = cards.every(card => card.cardStatus === 'Done');
      if (allCardsAreDone) {
        console.log("All cards are in 'Done' state. Updating sprint status to Completed.");
        const boardRef = doc(db, `tenants/${tenantId}/boards`, boardId);
        // Before updating, we can optionally check if the status is already 'Completed'
        // to avoid unnecessary database writes.
        getDoc(boardRef).then(boardSnap => {
          if (boardSnap.exists() && boardSnap.data().sprintStatus !== 'Completed') {
            updateDoc(boardRef, { sprintStatus: 'Completed' })
              .catch(error => console.error("Error updating sprint status:", error));
          }
        });
      }
    }
  }, [cards, boardId, boardType, tenantId, db]);

  // In CardPage.js
  useEffect(() => {
    // Ensure we have a projectId and boardType before running the query
    if (!projectId || !boardType) return;

    // Determine the correct base query based on the board type
    const baseQuery = boardType === 'Sprint'
      ? query(collection(db, "cards"), where("projectId", "==", projectId))
      : query(collection(db, "cards"), where("boardId", "==", boardId));

    // Set up the real-time listener
    const unsubscribe = onSnapshot(baseQuery, (snapshot) => {
      let fetchedCards = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // If it's a sprint board, we need to perform the second filtering step
      if (boardType === 'Sprint') {
        console.log("Sprint filtering debug:", {
          boardId,
          boardType,
          totalCardsBeforeFilter: fetchedCards.length,
          cardsWithSprints: fetchedCards.filter(card => Array.isArray(card.assignedSprints) && card.assignedSprints.length > 0).length
        });
        
        fetchedCards = fetchedCards.filter(card => {
          const hasSprints = Array.isArray(card.assignedSprints) && card.assignedSprints.length > 0;
          const matchesSprint = hasSprints && card.assignedSprints.some(sprint => sprint.boardId === boardId);
          
          if (hasSprints && !matchesSprint) {
            console.log("Card not matching sprint:", {
              cardId: card.cardId,
              cardSprints: card.assignedSprints.map(s => s.boardId),
              currentBoardId: boardId
            });
          }
          
          return matchesSprint;
        });
        
        console.log("Cards after sprint filter:", fetchedCards.length);
      }

      // Now, update the state with the correctly filtered cards
      setCards(fetchedCards);
      updateCardCounts(fetchedCards); // Make sure to update your card counts
      console.log("Total cards fetched: " + fetchedCards.length);
    });

    // Cleanup the listener when the component unmounts or dependencies change
    return () => unsubscribe();

  }, [boardId, projectId, boardType]); // Re-run this effect if the board, project, or type changes


  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'rules'), (snapshot) => {
      const fetchedRules = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setRules(fetchedRules.filter(rule => rule.isActive)); // Only use active rules
    });
    return () => unsubscribe();
  }, []);

  // Remove the useEffect that updates priority order since we're using only order field
  // useEffect(() => {
  //   updateAllCards();
  // }, []);

  // Remove priority order initialization since we're using direct priority field sorting
  // useEffect(() => {
  //   const initializeCards = async () => {
  //     try {
  //       // Add a flag to prevent multiple runs
  //       if (window.priorityOrderInitialized) {
  //         console.log('Priority order already initialized, skipping...');
  //         return;
  //       }
  //       
  //       console.log('Starting priority order initialization...');
  //       await updateAllCardsPriorityOrder();
  //       window.priorityOrderInitialized = true;
  //       console.log('Priority order initialization completed.');
  //     } catch (error) {
  //       console.error('Error initializing card priority orders:', error);
  //     }
  //   };
  //   initializeCards();
  // }, []); // Empty dependency array - only run once

  /* Not required
  useEffect(() => {
    if (!boardId) return; // Don't run if boardId is not available
    // Simple query that only filters by boardId - no orderBy clauses that require composite indexes
    const q = query(collection(db, "cards"), where("boardId", "==", boardId));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      try {
        const updatedCards = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // Sort cards in JavaScript instead of using Firestore orderBy
        const sortedCards = updatedCards.sort((a, b) => {
          // First sort by cardStatus
          if (a.cardStatus !== b.cardStatus) {
            return a.cardStatus.localeCompare(b.cardStatus);
          }
          // Then sort by priority (using existing priority field)
          const priorityOrder = { 'Urgent': 0, 'High': 1, 'Medium': 2, 'Low': 3 };
          const aPriority = priorityOrder[a.priority] ?? 99;
          const bPriority = priorityOrder[b.priority] ?? 99;
          return aPriority - bPriority;
        });
        
        console.log(`Loaded ${sortedCards.length} cards for board ${boardId}`);
        setCards(sortedCards);
  
        // Only update board/project details if they haven't been loaded yet
        if (!boardName || !prjName) {
          const updateBoardDetailsAndCounts = async () => {
            try {
              // Fetch board details only if not already cached
              if (!boardName) {
                const boardData = await fetchBoardDetails(boardId);
                if (boardData) {
                  setBoardName(boardData.boardName);
  
                  // Fetch project details only if not already cached
                  if (!prjName) {
                    const projectData = await fetchProjectDetails(boardData.projectId);
                    if (projectData) {
                      setPrjName(projectData.prjName);
                    } else {
                      console.error("Project not found");
                    }
                  }
                } else {
                  console.error("Board not found");
                }
              }
  
              // Update total cards
              setTotalCards(sortedCards.length);
  
              // Calculate cards per column
              const columnCardCounts = {};
              columns.forEach((column) => {
                columnCardCounts[column.name] = sortedCards.filter((card) => card.cardStatus === column.name).length;
              });
              setCardsPerColumn(columnCardCounts);
  
            } catch (error) {
              console.error('Error updating board details and counts:', error);
            }
          };
  
          updateBoardDetailsAndCounts();
        } else {
          // Just update card counts if board/project details are already loaded
          setTotalCards(sortedCards.length);
          const columnCardCounts = {};
          columns.forEach((column) => {
            columnCardCounts[column.name] = sortedCards.filter((card) => card.cardStatus === column.name).length;
          });
          setCardsPerColumn(columnCardCounts);
        }
  
      } catch (error) {
        console.error('Error processing card snapshot:', error);
      }
    }, (error) => {
      console.error('Error in card snapshot listener:', error);
    });
  
    return () => unsubscribe();
  }, [boardId, columns, boardName, prjName]); // Added boardName and prjName to dependencies
  */

  //Opens and closes the card dialog for adding or editing cards.
  const handleOpenDialog = () => {
    setSelectedCard(null);
    setDialogOpen(true);
  };

  const filteredCards = useMemo(() => {
      // Board filtering is now handled at the data fetching level
      // Only apply other filters here
      if (!filterType || !filterValue) {
          return cards; // If no filter is active, return all cards
      }

      return cards.filter((card) => {
          switch (filterType) {
              case "Assignee":
                  return (card.assigneeName || "") === filterValue;
              case "Card ID":
                  return (card.cardId || "") === filterValue;
              // Add other filter cases here if needed in the future
              default:
                  return true;
          }
      });
  }, [cards, filterType, filterValue]);

  // Handler for board filter selection - navigate to the selected board
  const handleBoardFilterChange = (selectedBoardId) => {
    if (selectedBoardId && selectedBoardId !== boardId) {
      // Navigate to the selected board's CardPage
      navigate(`/card-page/${selectedBoardId}`);
    }
  };

  // This function generates the options for the "Select Value" dropdown
  const getFilterOptions = () => {
      if (!filterType) {
          return [];
      }
      const options = new Set();

      // if (filterType === 'Assignee') {
      //     cards.forEach(card => {
      //         if (card && card.assigneeName) {
      //             options.add(card.assigneeName);
      //         }
      //     });
      // }
      cards.forEach(card => {
          if (!card) return;
          switch (filterType) {
              case 'Assignee':
                  if (card.assigneeName) {
                      options.add(card.assigneeName);
                  }
                  break;
              case 'Card ID':
                  if (card.cardId) {
                      options.add(card.cardId);
                  }
                  break;
              default:
                  break;
          }
      });
      return Array.from(options).sort();
  };


  ////Opens and closes the card dialog for adding or editing cards.
  const handleCloseDialog = () => {
    setSelectedCard(null);
    setDialogOpen(false);
    setRiskDialogOpen(false);
    setIssueDialogOpen(false);
    setCrmDialogOpen(false);
  };

  //Opens the card dialog with pre-filled data for editing a card.
  const handleOpenEditDialog = (card) => {
    setSelectedCard(card);
    if (card.cardType === 'Risk') {
      setRiskDialogOpen(true);
    } else if (card.cardType === 'Issue') {
      setIssueDialogOpen(true);
    } else if (card.cardType === 'CRM') {
      setCrmDialogOpen(true);
    } else {
      setDialogOpen(true);
    }
  };

  //Opens the card dialog with pre-filled data for duplicating a card (excluding attachments and comments).
  // Note: Duplicate functionality is only available for non-Risk cards
  const handleDuplicateCard = (card) => {
    // Create a copy of the card data excluding attachments and comments
    const duplicateData = {
      ...card,
      // Remove fields that should not be duplicated
      files: [], // Exclude attachments
      comments: [], // Exclude comments
      cardId: '', // Will be generated as new ID
      cardCreationDate: null, // Will be set to current date
      cardUpdatedByUserId: null, // Will be set to current user
      cardUpdatedOn: null, // Will be set to current date
      assignDate: null, // Will be set to current date
      createdAt: null, // Will be set to current date
      updatedAt: null, // Will be set to current date
      // Add a prefix to the task name to indicate it's a duplicate
      taskName: `Copy-${card.taskName}`,
      // Mark this as a duplicate so AddCardDialog knows to treat it as new card
      isDuplicate: true
    };
    
    setSelectedCard(duplicateData);
    setDialogOpen(true);
  };

  // New function to open import dialog
  const handleOpenImportDialog = () => {
    setImportDialogOpen(true);
  };

  // New function to close import dialog
  const handleCloseImportDialog = () => {
    setImportDialogOpen(false);
  };

  // New function to open export dialog
  const handleOpenExportDialog = () => {
    setExportDialogOpen(true);
  };

  // New function to close export dialog
  const handleCloseExportDialog = () => {
    setExportDialogOpen(false);
  };


  // Handle import cards
  const handleImportCards = async (cards) => {
    console.log('handleImportCards called with cards:', cards); // Log 1
    try {
      if (!cards || cards.length === 0) {
        console.log('No cards to import.'); // Log 2
        return;
      }

      const batch = writeBatch(db);
      console.log('Firestore batch initialized.'); // Log 3

      // Fetch the current last serial number for the project
      const projectRef = doc(db, 'projects', projectId);
      const projectSnap = await getDoc(projectRef);
      let currentSerialNumber = 0;
      if (projectSnap.exists() && projectSnap.data().lastSerialNumber !== undefined) {
        currentSerialNumber = projectSnap.data().lastSerialNumber;
      }
      const projectPrefix = prjName ? prjName.split(' ').map(word => word.charAt(0)).join('').toUpperCase() + '-' : '';

      // Define a mapping from potential CSV headers to internal card field names
      const headerMapping = {
        'Summary': 'taskName',
        'Description': 'description',
        'CardStatus': 'cardStatus', // Primary expected header
        'Status': 'cardStatus', // Alternative header
        'Task Status': 'cardStatus', // Another alternative
        'DueDate': 'dueDate',
        'CardType': 'cardType',
        'Priority': 'priority',
        'AcceptanceCriteria': 'acceptanceCriteria',
        'Estimate': 'estimate',
        'AssigneeName': 'assigneeName',
        // Add other potential header mappings here if needed
      };

      for (const cardData of cards) { // Renamed 'card' to 'cardData' to avoid confusion
        console.log('Processing card data from CSV:', cardData); // Log   
        currentSerialNumber++;
        const generatedCardId = projectPrefix + currentSerialNumber;
        const cardRef = doc(db, "cards", generatedCardId); // Use generated ID as document ID
        const newCard = {};

        // Map CSV data to new card object based on mapping
        for (const csvHeader in cardData) {
          const cardField = headerMapping[csvHeader.trim()]; // Trim header for robustness
          if (cardField) {
            newCard[cardField] = cardData[csvHeader];
          }
        }

        // Ensure required fields are present or set defaults
        newCard.taskName = newCard.taskName || 'Untitled Card'; // Ensure Summary is present
        newCard.cardStatus = newCard.cardStatus || 'To Do'; // Ensure CardStatus has a default
        newCard.cardType = newCard.cardType || 'Task'; // Ensure CardType has a default
        newCard.priority = newCard.priority || 'Low'; // Ensure Priority has a default
        // Add defaults for other fields if necessary

        // Add other required fields for Firestore document
        newCard.boardId = boardId; // Use the boardId from CardPage params
        newCard.cardId = generatedCardId; // Use the generated serial ID
        newCard.cardProjectName = prjName; // Use prjName from CardPage state
        newCard.cardCreatedByUserId = /* TODO: Get current user ID in CardPage */ '';
        newCard.cardCreationDate = new Date().toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }).replace(/ /g, "-");
        newCard.cardUpdatedByUserId = /* TODO: Get current user ID in CardPage */ '';
        newCard.cardUpdatedOn = new Date().toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        newCard.comments = [];
        newCard.files = [];

        console.log('New card object being saved:', newCard); // Log C: Inspect the card object before saving
        batch.set(cardRef, newCard); // Use the document reference with generated ID
        console.log('Added card to batch:', newCard); // Log 5
      }

      console.log('Committing batch...'); // Log 6
      await batch.commit();
      console.log('Batch committed successfully.'); // Log 7

      // Update the last serial number in the project document
      await updateDoc(projectRef, {
        lastSerialNumber: currentSerialNumber
      });
      console.log('Updated last serial number in project document after import.');

      // Add log for visibleCards after state update
      console.log('Visible cards after update:', cards.filter(card =>
        rules.filter(rule => rule.isActive)
          .flatMap(rule => (rule.blocks || []).filter(
            block => (block.actions || []).some(action => action.value === 'show_only_matching')
          ))
          .some(block => cardMatchesBlock(card, block))
      )); // Log 9a

    } catch (error) {
      console.error('Error importing cards:', error); // Log 10: Catch any errors during the process
      // Potentially show an error message to the user
    }
  };

  // Handle card save (add or edit)
  const handleSaveCard = async (card) => {
    try {
      const fileURL = uploadedFileURL;
      const fileType = uploadedFileType;

      if (!fileURL) {
        console.warn("No file uploaded, saving card without attachment.");
      }

      // For duplicates, don't pass selectedCard so it creates a new card instead of updating
      const cardToPass = (selectedCard && selectedCard.isDuplicate) ? null : selectedCard;
      const updatedCards = await saveCard(card, card.boardId, cardToPass, cards, tenantId);

      if (updatedCards) {
        // If the card was moved to a different board, remove it from the current board's state
        if (card.boardId !== boardId) {
          setCards(prevCards => prevCards.filter(c => c.id !== card.id));
        } else {
          setCards(updatedCards);
        }
        updateCardCounts(updatedCards.filter(c => c.boardId === boardId)); // Update counts for current board only
        handleCloseDialog();
      } else {
        console.error("Failed to save card.");
      }
    } catch (error) {
      console.error("Error saving card:", error);
    }
  };

  //Logs the user out by clearing sessionStorage and redirecting to the homepage.
  const handleLogout = () => {
    console.log('Logout function called');
    localStorage.removeItem('userData');
    window.location.href = '/';
  };

  const handleDeleteCard = async (id) => {
    try {
      const success = await deleteTask(id); // Call the reusable function

      if (success) {
        setCards((prevCards) => {
          const updatedCards = prevCards.filter((card) => card.id !== id);
          updateCardCounts(updatedCards); // Update card counts after deletion
          return updatedCards;
        });
      } else {
        console.error("Failed to delete card.");
      }
    } catch (error) {
      console.error("Error deleting card:", error);
    }
  };

  // card removal/deletion based on board type (major change)
  const handleCardDeletionOrRemoval = async (cardId) => {
  const cardToDelete = cards.find(c=> c.id === cardId);
    // Check the board type.
  if (boardType === 'Sprint') {
    // Action for Sprint Boards: Remove from assignedSprints array
    if (!window.confirm("Are you sure you want to remove this card from the sprint?")) return;
    
    const cardRef = doc(db, "cards", cardId); // Correct path based on your screenshot
    try {
      const cardSnap = await getDoc(cardRef);
      if (cardSnap.exists()) {
        const cardData = cardSnap.data();
        const updatedSprints = cardData.assignedSprints.filter(sprint => sprint.boardId !== boardId);
        await updateDoc(cardRef, { assignedSprints: updatedSprints });
      } else {
        console.error("Card not found.");
      }
    } catch (error) {
      console.error("Error removing card from sprint:", error);
    }
  } else {    
    // Check if the card is assigned to any sprints
    if (cardToDelete.assignedSprints && cardToDelete.assignedSprints.length > 0) {
        // If it is, show the warning pop-up and stop
        const sprintNames = cardToDelete.assignedSprints.map(sprint => sprint.boardName).join(', ');
        alert(`Cannot Delete Card\n\nThis card is part of an active sprint: "${sprintNames}". Items in a sprint cannot be deleted directly. To proceed, please remove the card from the sprint first.`);
        return; // Stop the deletion process
    }
    if (window.confirm("Are you sure you want to permanently delete this card?")) {
      try {
        // Pass tenantId if your deleteTask function requires it for other collections
        await deleteTask(cardId, tenantId);
      } catch (error) {
        console.error("Error deleting card:", error);
      }
    }
  }
};

  //Called when dragging starts on a card, storing the card information.
  const handleDragStart = (event, card) => {
    setDraggingCard(card);
    event.dataTransfer.setData('text/plain', card.id);
  };


  //Handles drag-over events, including triggering auto-scrolling when near the top or bottom of the screen.

  const handleDragOver = (event) => {
    event.preventDefault();

    const { clientY } = event; // Get the Y position of the drag event
    const threshold = 100; // Distance from top or bottom to trigger auto-scroll

    // Auto-scroll upwards if near the top of the screen
    if (clientY < threshold) {
      setScrollDirection('up');
    }
    // Auto-scroll downwards if near the bottom of the screen
    else if (window.innerHeight - clientY < threshold) {
      setScrollDirection('down');
    } else {
      setScrollDirection(null);
    }

    // Check if we're dragging over a card element
    const cardElement = event.target.closest('[data-card-id]');
    if (cardElement && draggingCard) {
      const targetCardId = cardElement.getAttribute('data-card-id');
      if (targetCardId && targetCardId !== draggingCard.id) {
        setDragOverCard(targetCardId);
      }
    } else {
      setDragOverCard(null);
    }
  };

  const handleDrop = async (event, column) => {
    event.preventDefault();
    setScrollDirection(null); // Stop auto-scrolling on drop

    const cardId = event.dataTransfer.getData('text/plain');
    const card = cards.find(c => c.id === cardId);

    if (!card) {
      console.error('Card not found');
      return;
    }

    // Check if we're dropping on another card (reordering within same column)
    const cardElement = event.target.closest('[data-card-id]');
    if (cardElement && card.cardStatus === column.name) {
      const targetCardId = cardElement.getAttribute('data-card-id');
      if (targetCardId && targetCardId !== cardId) {
        await handleCardReorder(cardId, targetCardId, column.name);
        setDragOverCard(null);
        setDraggingCard(null);
        return;
      }
    }

    // If not reordering, check if the transition is allowed (moving between columns)
    const allowed = isTransitionAllowed(card.cardStatus, column.name);
    if (!allowed) {
      alert(`Moving cards from "${card.cardStatus}" to "${column.name}" is not allowed. Please check the Card Movement Settings.`);
      return;
    }

    try {
      const updatedCards = cards.map((c) =>
        c.id === cardId ? { ...c, cardStatus: column.name } : c
      );
      setCards(updatedCards);

      // Call handleStatusChange to send email notification
      const newStatus = column.name;
      await handleStatusChange(cardId, newStatus);

      const cardDoc = doc(db, 'cards', cardId);
      await updateDoc(cardDoc, { cardStatus: column.name });

      // Update total cards and cards per column after dropping
      updateCardCounts(updatedCards);
    } catch (error) {
      console.error('Error updating card status:', error);
      alert('Failed to update card status. Please try again.');
    }

    setDraggingCard(null);
    setDragOverCard(null);
  };

  // Function to handle card reordering within the same column
  const handleCardReorder = async (draggedCardId, targetCardId, columnName) => {
    try {
      // Get the cards in the current column, sorted by their current order
      const columnCards = cards
        .filter(card => card.cardStatus === columnName)
        .sort((a, b) => (a.order ?? 999) - (b.order ?? 999));

      // Find the indices of the dragged and target cards
      const draggedIndex = columnCards.findIndex(card => card.id === draggedCardId);
      const targetIndex = columnCards.findIndex(card => card.id === targetCardId);

      if (draggedIndex === -1 || targetIndex === -1) return;
      if (draggedIndex === targetIndex) return; // No-op if dropped on itself

      // Create a new array with the reordered cards
      const reorderedCards = [...columnCards];
      const [draggedCard] = reorderedCards.splice(draggedIndex, 1);
      reorderedCards.splice(targetIndex, 0, draggedCard);

      // Update the order field for each card in the column
      const updatedCards = cards.map(card => {
        if (card.cardStatus === columnName) {
          const newIndex = reorderedCards.findIndex(reorderedCard => reorderedCard.id === card.id);
          return { ...card, order: newIndex };
        }
        return card;
      });

      setCards(updatedCards);

      // Update the database
      const batch = writeBatch(db);
      reorderedCards.forEach((card, index) => {
        const cardRef = doc(db, 'cards', card.id);
        batch.update(cardRef, { order: index });
      });
      await batch.commit();
    } catch (error) {
      console.error('Error reordering cards:', error);
    }
  };

  // Remove the priorityOrderMap and updateAllCardsPriorityOrder function since they're no longer needed
  // const priorityOrderMap = { 'Urgent': 0, 'High': 1, 'Medium': 2, 'Low': 3 };

  // async function updateAllCardsPriorityOrder() {
  //   try {
  //     console.log('Starting priority order update for all cards...');
  //     const cardsSnapshot = await getDocs(collection(db, "cards"));

  //     if (cardsSnapshot.empty) {
  //       console.log('No cards found to update priority order');
  //       return;
  //     }

  //     const batch = writeBatch(db);
  //     let updateCount = 0;

  //     cardsSnapshot.forEach((cardDoc) => {
  //       const cardData = cardDoc.data();
  //       const priority = cardData.priority || 'Low';
  //       const priorityOrder = priorityOrderMap[priority] ?? 99;

  //       // Only update if priorityOrder is missing or different
  //       if (cardData.priorityOrder === undefined || cardData.priorityOrder !== priorityOrder) {
  //         batch.update(doc(db, "cards", cardDoc.id), { priorityOrder });
  //         updateCount++;
  //       }
  //     });

  //     if (updateCount > 0) {
  //       await batch.commit();
  //       console.log(`Updated priority order for ${updateCount} cards`);
  //     } else {
  //       console.log('No cards needed priority order updates');
  //     }
  //   } catch (error) {
  //     console.error('Error updating card priority orders:', error);
  //     throw error; // Re-throw to be handled by caller
  //   }
  // }

  const updateCardCounts = (updatedCards = cards) => {
    // Update total cards
    setTotalCards(updatedCards.length);

    // Update cards per column
    const columnCardCounts = {};
    columns.forEach((column) => {
      columnCardCounts[column.name] = updatedCards.filter((card) => card.cardStatus === column.name).length;
    });
    setCardsPerColumn(columnCardCounts);
  };


  const handleStatusChange = async (cardId, newStatus) => {
    const card = cards.find((c) => c.id === cardId);
    if (!card) return;

    try {
      // Fetch creator and assignee names
      const createdByUserName = await fetchUserNameById(card.cardCreatedByUserId);
      const assigneeName = card.assigneeName;

      // console.log("Creator Username:", createdByUserName); // Commented out to avoid revealing user data
      // console.log("Assignee Username:", assigneeName); // Commented out to avoid revealing user data

      // Fetch Emails using fetchUserEmailById by using userId instead of username
      const createdByUserEmail = await fetchUserEmailById(card.cardCreatedByUserId);

      // If assigneeName is a username, find the matching user
      let assigneeEmail = null;
      const { users } = await fetchUsersAndTenants();
      const assigneeData = users.find(user => user.userName === assigneeName);
      if (assigneeData) {
        assigneeEmail = assigneeData.email;
      } else {
        console.error(`No user found with the username: ${assigneeName}`);
      }

      // console.log("Creator Email:", createdByUserEmail || "Not Found"); // Commented out to avoid revealing user data
      // console.log("Assignee Email:", assigneeEmail || "Not Found"); // Commented out to avoid revealing user data

      if (!createdByUserEmail && !assigneeEmail) {
        console.error("No valid email found for assignee or creator.");
        return;
      }

      // Update card status
      const cardRef = doc(db, 'cards', cardId);
      await updateDoc(cardRef, {
        cardStatus: newStatus,
        cardUpdatedOn: new Date().toISOString()
      });

      // Email details
      const emailDetails = {
        cardName: card.taskName,
        taskId: card.cardId,
        description: card.description || "N/A",
        assigneeName: card.assigneeName || "N/A",
        priority: card.priority || "N/A",
        status: card.cardStatus || "N/A",
        newStatus,
        dueDate: card.dueDate ? new Date(card.dueDate).toLocaleDateString() : "N/A",
        estimate: card.estimate ? `${card.estimate} hrs` : "N/A",
        acceptanceCriteria: card.acceptanceCriteria || "N/A",
        assignDate: card.assignDate ? new Date(card.assignDate).toLocaleDateString() : "N/A",
        subtasks: card.subtasks?.length > 0 ? card.subtasks : "N/A",
        webAppLink: "https://ovplan1.web.app",
      };

      // Send email notifications
      if (createdByUserEmail) {
        await sendEmail(createdByUserEmail, `Card Status Updated: ${card.taskName}`, emailDetails);
      }
      if (assigneeEmail) {
        await sendEmail(assigneeEmail, `Card Status Updated: ${card.taskName}`, emailDetails);
      }

      // Refresh the cards list
      const updatedCards = cards.map(c =>
        c.id === cardId ? { ...c, cardStatus: newStatus } : c
      );
      setCards(updatedCards);
    } catch (error) {
      console.error("Error updating card status:", error);
    }
  };

  //When dragging a card near the top or bottom of the screen, it triggers an auto-scroll mechanism. 
  useEffect(() => {
    let scrollInterval = null;

    if (scrollDirection) {
      scrollInterval = setInterval(() => {
        if (scrollDirection === 'up') {
          window.scrollBy(0, -scrollSpeed);
        } else if (scrollDirection === 'down') {
          window.scrollBy(0, scrollSpeed);
        }
      }, 50); // Scroll every 50ms
    }

    return () => {
      if (scrollInterval) {
        clearInterval(scrollInterval);
      }
    };
  }, [scrollDirection]);



  // Handler to open the transition settings dialog
  const handleOpenTransitionSettings = () => {
    setOpenTransitionSettings(true);
  };

  // Handler to close the transition settings dialog
  const handleCloseTransitionSettings = () => {
    setOpenTransitionSettings(false);
  };

  // Handler to save changes to the transition matrix
  // This is called when the user clicks save in the TransitionMatrixSettings dialog
  const handleTransitionMatrixSave = async (newMatrix) => {
    try {
      // Attempt to update the matrix with the new configuration
      // Pass the current user's role for permission checking
      await setTransitionMatrix(newMatrix, role);
    } catch (error) {
      // If there's an error (e.g., unauthorized), show it to the user
      console.error('Error saving transition matrix:', error);
      alert(error.message);
    }
  };

  // Handler to reset the transition matrix to default
  // This is called when the user clicks reset in the TransitionMatrixSettings dialog
  const handleTransitionMatrixReset = async () => {
    try {
      // Attempt to reset the matrix to default (allows all transitions)
      // Pass the current user's role for permission checking
      await resetTransitionMatrix(role);
    } catch (error) {
      // If there's an error (e.g., unauthorized), show it to the user
      console.error('Error resetting transition matrix:', error);
      alert(error.message);
    }
  };

  // Horizontal scroll functions
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: 'smooth'
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: 'smooth'
      });
    }
  };

  const updateScrollButtons = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  // Utility to check if a card matches a block's conditions
  function cardMatchesBlock(card, block) {
    return (block.conditions || []).every(cond => {
      let cardField = cond.field;
      if (cardField === 'status') cardField = 'cardStatus';
      const cardValue = card[cardField];
      switch (cond.operator) {
        case 'equals':
          return cardValue === cond.value;
        case 'not_equals':
          return cardValue !== cond.value;
        case 'greater_than':
          return cardValue > cond.value;
        case 'less_than':
          return cardValue < cond.value;
        default:
          return false;
      }
    });
  }

  // Filter cards for show_only_matching_cards logic
  const matchingBlocks = rules
    .filter(rule => rule.isActive)
    .flatMap(rule => (rule.blocks || []).filter(
      block => (block.actions || []).some(action => action.value === 'show_only_matching')
    ));
  let visibleCards = cards;
  if (matchingBlocks.length > 0) {
    visibleCards = cards.filter(card =>
      matchingBlocks.some(block => cardMatchesBlock(card, block))
    );
  }

  useEffect(() => {
    console.log('Rules useEffect triggered.', { cardsSize: cards.length, rulesSize: rules.length });

    // Add guards to prevent excessive processing
    if (!cards || !rules || rules.length === 0 || cards.length === 0) {
      console.log('Rules useEffect: Skipping due to missing cards or rules.');
      return;
    }

    // Add a flag to prevent multiple simultaneous rule processing
    if (window.isProcessingRules) {
      console.log('Rules useEffect: Skipping - already processing rules.');
      return;
    }

    window.isProcessingRules = true;

    const cardsToUpdate = [];
    console.log('Rules useEffect: Initializing cardsToUpdate.');

    rules.forEach(rule => {
      if (rule.isActive && rule.blocks) {
        rule.blocks.forEach(block => {
          const hasMoveToWithdrawnAction = block.actions && block.actions.some(action => action.value === 'move_to_withdrawn');

          if (hasMoveToWithdrawnAction && block.conditions && block.conditions.length > 0) {
            console.log(`Rules useEffect: Processing rule ${rule.id} with move_to_withdrawn action.`);
            cards.forEach(card => {
              // Check if the card is not already in the withdrawn column
              if (card.cardStatus !== 'Withdrawn' && cardMatchesRule(card, { conditions: block.conditions })) {
                console.log(`Rules useEffect: Card ${card.id} matches conditions for move to Withdrawn.`, card);
                // Add the card to the list of cards to update if not already present
                if (!cardsToUpdate.some(c => c.id === card.id)) {
                  console.log(`Rules useEffect: Adding card ${card.id} to cardsToUpdate.`);
                  cardsToUpdate.push({ ...card, cardStatus: 'Withdrawn' });
                }
              } else {
                console.log(`Rules useEffect: Card ${card.id} does not match conditions or is already Withdrawn.`, card);
              }
            });
          }
        });
      }
    });

    // Update the cards in the database and state
    const updateCards = async () => {
      console.log('Rules useEffect: Starting updateCards async function.', cardsToUpdate);
      for (const updatedCard of cardsToUpdate) {
        try {
          console.log(`Rules useEffect: Attempting to save card ${updatedCard.cardId} to Withdrawn.`);
          await saveCard(updatedCard, updatedCard.boardId, updatedCard, cards, tenantId);
          console.log(`Rules useEffect: Card ${updatedCard.cardId} successfully saved to Withdrawn.`);
        } catch (error) {
          console.error(`Rules useEffect: Error moving card ${updatedCard.cardId} to Withdrawn:`, error);
        }
      }
      console.log('Rules useEffect: Finished updateCards async function.');
      window.isProcessingRules = false; // Reset the flag
    };

    if (cardsToUpdate.length > 0) {
      console.log(`Rules useEffect: ${cardsToUpdate.length} cards to update. Calling updateCards().`);
      updateCards();
    } else {
      console.log('Rules useEffect: No cards to update.');
      window.isProcessingRules = false; // Reset the flag
    }

  }, [cards, rules, tenantId]); // Removed saveCard from dependencies to prevent infinite loops


  // Cleanup function for global flags
  useEffect(() => {
    return () => {
      // Clean up global flags when component unmounts
      delete window.isProcessingRules;
      // delete window.priorityOrderInitialized; // No longer needed
    };
  }, []);

  // Effect to handle scroll events and update scroll buttons
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    const handleScroll = () => {
      updateScrollButtons();
    };

    const handleResize = () => {
      updateScrollButtons();
    };

    // Initial check
    updateScrollButtons();

    // Add event listeners
    scrollContainer.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [columns]); // Re-run when columns change


  return (
  <Box sx={{ display: 'flex', minHeight: '100vh', background: 'linear-gradient(white, #6495ED)' }}>
      <CssBaseline />
      <SideDrawer projectId={projectId} />
      <Navbar handleLogout={handleLogout} boardName={boardName} prjName={prjName} />

      <Box component="main" sx={{
        flexGrow: 1,
        p: 2,
        position: 'relative',
        minHeight: '100vh',
        overflowY: 'auto',
        background: 'linear-gradient(white, #6495ED)'
      }}>
        <Box sx={{ height: '48px' }} /> {/* Reduced spacer to match new navbar height */}
        
        {/* Top section with filters and action icons */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 1 }}>
          {/* Left side - existing filters */}
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 150, backgroundColor: 'white' }}>
              <InputLabel>Filter By</InputLabel>
              <Select
                value={filterType}
                onChange={(e) => {
                  setFilterType(e.target.value);
                  setFilterValue("");
                }}
                label="Filter By"
              >
                <MenuItem value=""><em>None</em></MenuItem>
                <MenuItem value="Assignee">Assignee</MenuItem>
                <MenuItem value="Card ID">Card ID</MenuItem>
              </Select>
            </FormControl>

            {filterType && (
              <FormControl variant="outlined" size="small" sx={{ minWidth: 150, backgroundColor: 'white' }}>
                <InputLabel>Select Value</InputLabel>
                <Select
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                  label="Select Value"
                >
                  {getFilterOptions().map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}

            {/* Action Icons */}
            <Box sx={{ display: 'flex', gap: 1, ml: 2 }}>
              {/* Card Transitions Settings - Admin only */}
              {(role.toLowerCase() === 'admin' || role.toLowerCase() === 'tenant admin') && (
                <Tooltip title="Card Movement Settings">
                  <IconButton
                    onClick={handleOpenTransitionSettings}
                    sx={{
                      color: '#1976d2', // Blue icon
                      backgroundColor: 'rgba(255, 255, 255, 0.9)', // White fill
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 1)' // Solid white on hover
                      }
                    }}
                  >
                    <SettingsIcon />
                  </IconButton>
                </Tooltip>
              )}

              {/* Import/Export - Admin and Super Admin only */}
              {(userRole === 'admin' || userRole === 'tenant admin' || userRole === 'super admin') && (
                <>
                  <Tooltip title="Import Cards">
                    <IconButton
                      onClick={handleOpenImportDialog}
                      sx={{
                        color: '#1976d2', // Blue icon
                        backgroundColor: 'rgba(255, 255, 255, 0.9)', // White fill
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 1)' // Solid white on hover
                        }
                      }}
                    >
                      <CloudUploadIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Export Cards">
                    <IconButton
                      onClick={handleOpenExportDialog}
                      sx={{
                        color: '#1976d2', // Blue icon
                        backgroundColor: 'rgba(255, 255, 255, 0.9)', // White fill
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 1)' // Solid white on hover
                        }
                      }}
                    >
                      <FileDownloadIcon />
                    </IconButton>
                  </Tooltip>
                </>
              )}

              {/* View Toggle - All users */}
              <Tooltip title={viewMode === 'kanban' ? "Switch to List View" : "Switch to Kanban View"}>
                <IconButton
                  onClick={() => setViewMode(viewMode === 'kanban' ? 'list' : 'kanban')}
                  sx={{
                    color: '#1976d2', // Black icon
                    backgroundColor: 'rgba(255, 255, 255, 0.9)', // White fill
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)' // Solid white on hover
                    }
                  }}
                >
                  {viewMode === 'kanban' ? <ViewListIcon /> : <ViewModuleIcon />}
                </IconButton>
              </Tooltip>

              {/* Add Card - All users */}
              <Tooltip title={
                boardTemplateType === 'Risk Management' ? "Add Risk Card" : 
                boardTemplateType === 'Issue Management' ? "Add Issue Card" : 
                boardTemplateType === 'CRM' ? "Add CRM Card" :
                "Add Card"
              }>
                <IconButton
                  onClick={
                    boardTemplateType === 'Risk Management' ? () => setRiskDialogOpen(true) : 
                    boardTemplateType === 'Issue Management' ? () => setIssueDialogOpen(true) :
                    boardTemplateType === 'CRM' ? () => setCrmDialogOpen(true) :
                    handleOpenDialog
                  }
                  sx={{
                    color: '#1976d2', // Blue icon for both types
                    backgroundColor: 'rgba(255, 255, 255, 0.9)', // White fill
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 1)' // Solid white on hover
                    }
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {/* Right side - Board filter */}
          <FormControl variant="outlined" size="small" sx={{ minWidth: 200, backgroundColor: 'white' }}>
            <InputLabel>Switch Board</InputLabel>
            <Select
              value={boardId}
              onChange={(e) => handleBoardFilterChange(e.target.value)}
              label="Switch Board"
            >
              <MenuItem value={boardId} disabled>
                <em>{boardName || 'Current Board'}</em>
              </MenuItem>
              {availableBoards.map((board) => (
                <MenuItem key={board.id || board.boardId} value={board.id || board.boardId}>
                  {board.boardName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Conditional Rendering based on View Mode */}
        {viewMode === 'kanban' ? (
          /* Kanban View */
          <Box sx={{ 
            position: 'relative', 
            width: '100%',
            minHeight: 'calc(100vh - 140px)', // Allow content to expand beyond viewport
            overflowY: 'visible' // Allow vertical overflow for page scrolling
          }}>
            {/* Left Scroll Button - Always visible */}
            <IconButton
              onClick={scrollLeft}
              sx={{
                position: 'fixed',
                left: 72, // Positioned to the right of the sidebar (64px + 8px margin)
                top: '50vh',
                transform: 'translateY(-50%)',
                zIndex: 1000,
                backgroundColor: 'rgba(169, 169, 169, 0.8)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                '&:hover': {
                  backgroundColor: 'rgba(192, 192, 192, 1)',
                },
              }}
            >
              <ChevronLeftIcon />
            </IconButton>

            {/* Right Scroll Button - Always visible */}
            <IconButton
              onClick={scrollRight}
              sx={{
                position: 'fixed',
                right: 8,
                top: '50vh',
                transform: 'translateY(-50%)',
                zIndex: 1000,
                backgroundColor: 'rgba(191, 191, 191, 0.9)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                '&:hover': {
                  backgroundColor: 'rgba(192, 192, 192, 1)',
                },
              }}
            >
              <ChevronRightIcon />
            </IconButton>

            {/* Scrollable Container */}
            <Box
              ref={scrollContainerRef}
              sx={{
                overflowX: 'auto',
                overflowY: 'visible', // Allow vertical overflow for page scrolling
                width: '100%',
                minHeight: '100%', // Allow content to expand
                '&::-webkit-scrollbar': {
                  height: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: 'rgba(0,0,0,0.1)',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  borderRadius: '4px',
                  '&:hover': {
                    backgroundColor: 'rgba(0,0,0,0.5)',
                  },
                },
                // Smooth scrolling behavior
                scrollBehavior: 'smooth',
                // Ensure proper spacing
                paddingBottom: '16px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: 0.5,
                  minWidth: 'max-content',
                  padding: '0 8px',
                  minHeight: '100%', // Allow content to expand
                  alignItems: 'flex-start',
                }}
              >
                {columns.map((column) => (
                  <Box
                    key={column.id}
                    sx={{
                      minWidth: '280px',
                      maxWidth: '320px',
                      flexShrink: 0,
                      padding: 1,
                      boxSizing: 'border-box',
                      height: '100%', // Use full available height
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Column
                      column={column}
                      cards={filteredCards.filter(card => card.cardStatus === column.name)}
                      handleDragOver={handleDragOver}
                      handleDrop={handleDrop}
                      handleDragStart={handleDragStart}
                      handleOpenEditDialog={handleOpenEditDialog}
                      handleDeleteCard={handleCardDeletionOrRemoval}
                      handleDuplicateCard={handleDuplicateCard}
                      isSprintContext={boardType === 'Sprint'}                  
                      rules={rules}
                      dragOverCard={dragOverCard}
                      columns={columns}
                      isRiskManagementTemplate={boardTemplateType === 'Risk Management'}
                      isIssueManagementTemplate={boardTemplateType === 'Issue Management'}
                      isCRMTemplate={boardTemplateType === 'CRM'}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        ) : (
          /* List View */
          <TableContainer component={Paper} sx={{ mt: 3 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>ID</strong></TableCell>
                  <TableCell><strong>Summary</strong></TableCell>
                  <TableCell><strong>Type</strong></TableCell>
                  <TableCell><strong>Status</strong></TableCell>
                  <TableCell><strong>Priority</strong></TableCell>
                  <TableCell><strong>Due Date</strong></TableCell>
                  <TableCell><strong>Assigned To</strong></TableCell>
                  <TableCell><strong>Actions</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredCards.map((card) => (
                  <TableRow key={card.cardId}>
                      <TableCell>{card.cardId}</TableCell>
                    <TableCell sx={{
                      maxWidth: "200px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}>
                      <Tooltip title={
                        boardTemplateType === 'Risk Management' ? (card.summary || card.riskSummary || '') : 
                        boardTemplateType === 'Issue Management' ? (card.summary || card.templateData?.issueSummary || '') :
                        boardTemplateType === 'CRM' ? (card.summary || card.templateData?.name || '') :
                        (card.taskName || '')
                      }>
                        <span>{
                          boardTemplateType === 'Risk Management' ? (card.summary || card.riskSummary || '') : 
                          boardTemplateType === 'Issue Management' ? (card.summary || card.templateData?.issueSummary || '') :
                          boardTemplateType === 'CRM' ? (card.summary || card.templateData?.name || '') :
                          (card.taskName || '')
                        }</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{card.cardType}</TableCell>
                    <TableCell>{card.cardStatus}</TableCell>
                    <TableCell>{card.priority}</TableCell>
                    <TableCell>{card.dueDate}</TableCell>
                    <TableCell>{card.assigneeName}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <IconButton onClick={() => handleOpenEditDialog(card)} size="small">
                          <EditIcon color="primary" />
                        </IconButton>
                        <IconButton onClick={() => handleCardDeletionOrRemoval(card.id)} size="small">
                          <DeleteIcon color="error" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
                {filteredCards.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No cards found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

      </Box>


      {/* Add Card Dialog (Standard) */}
      <AddCardDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        onSave={handleSaveCard}
        initialData={selectedCard}
        columns={columns}
        boardName={boardName}
        prjName={prjName}
        email={email}
        projectId={projectId}
      />

      {/* Add Risk Card Dialog (Risk Management Template) */}
      <AddRiskCardDialog
        open={riskDialogOpen}
        onClose={handleCloseDialog}
        onSave={handleSaveCard}
        initialData={selectedCard}
        prjName={prjName}
        boardId={boardId}
        projectId={projectId}
        tenantId={tenantId}
        userId={userId}
        userName={userData?.userName || email}
      />

      {/* Add Issue Card Dialog (Issue Management Template) */}
      <AddIssueCardDialog
        open={issueDialogOpen}
        onClose={handleCloseDialog}
        onSave={handleSaveCard}
        initialData={selectedCard}
        prjName={prjName}
        boardId={boardId}
        projectId={projectId}
        tenantId={tenantId}
        userId={userId}
        userName={userData?.userName || email}
      />

      {/* Add CRM Card Dialog (CRM Template) */}
      <AddCRMCardDialog
        open={crmDialogOpen}
        onClose={handleCloseDialog}
        onSave={handleSaveCard}
        initialData={selectedCard}
        prjName={prjName}
        boardId={boardId}
        projectId={projectId}
        tenantId={tenantId}
        userId={userId}
        userName={userData?.userName || email}
      />

      {/* Import Cards Dialog */}
      <ImportCardsDialog
        open={importDialogOpen}
        onClose={handleCloseImportDialog}
        onImport={handleImportCards}
        boardId={boardId}
      />

      {/* Export Cards Dialog */}
      <ExportCardsDialog
        open={exportDialogOpen}
        onClose={handleCloseExportDialog}
        cards={cards}
        boardName={boardName}
        boardId={boardId}
      />

      {/* Card Movement Settings Dialog */}
      {(role.toLowerCase() === 'admin' || role.toLowerCase() === 'tenant admin') && (
        <Dialog
          open={openTransitionSettings}
          onClose={handleCloseTransitionSettings}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Card Movement Settings</DialogTitle>
          <DialogContent>
            <TransitionMatrixSettings
              projectId={projectId}
              columns={columns.map(col => col.name)}
              onSave={handleTransitionMatrixSave}
              onReset={handleTransitionMatrixReset}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTransitionSettings}>Close</Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
}

export default CardPage;






